import React from 'react';
import UsersAdminLayout from '../components/administration/UsersAdminLayout';

function UsersPage() {
  return <UsersAdminLayout />;
}

export default UsersPage;
